import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* eslint-disable no-undefined */
export var DATA_GRID_DISPLAY_NAME = "DataGrid";
export var defaultPropertiesOverride = {
  role: undefined
};
export var defaultSortPropertiesOverride = _objectSpread(_objectSpread({}, defaultPropertiesOverride), {}, {
  colSpan: undefined,
  title: undefined
});
export var ITEMS_PER_PAGE_AND_VISIBLE_PAGES_MAP = {
  "10": 10,
  "25": 8,
  "50": 4,
  "100": 3
};
export var ERROR_MSG = "Select at least one filter";
export var INTERNAL_USER_ONLY = "Internal use only";